export interface FornecedorDTO {
  id: number;
  nome: string;
  cnpj: string;
}

/**
 * Fornecedor nas rotas de Compras (lista / estado da tela).
 * `BuscarFornecedores` pode retornar `nome`; unificamos em `descricao` no front.
 */
export interface FornecedorApi {
  id: number;
  descricao: string;
  cnpj: string;
}

/** Body de `POST /api/Compras/AdicionarFornecedor` */
export interface FornecedorAdicionarRequest {
  id: number;
  nome: string;
  cnpj: string;
}

export interface ProdutosCompraDTO {
  id: number;
  descricao: string;
  quantidade: number;
  valorUnitario: number;
  iDProdutoEstoque: number;
}

export interface Compra {
  id: number;
  valorTotal: number;
  excluido: boolean;
  fornecedor: FornecedorDTO;
  produtos: ProdutosCompraDTO[];
}

export interface FiltroComprasRequest {
  dataInicial: string;
  dataFinal: string;
  nomeFornecedor?: string;
}

// Interfaces auxiliares para o componente (mantidas para compatibilidade)
export interface CompraItem {
  id: number;
  compraId: number;
  produtoId: number;
  produtoDescricao: string;
  quantidade: number;
  valorUnitario: number;
  valorTotal: number;
}

export const initialCompra: Compra = {
  id: 0,
  valorTotal: 0,
  excluido: false,
  fornecedor: {
    id: 0,
    nome: "",
    cnpj: "",
  },
  produtos: [],
};

export const initialCompraItem: CompraItem = {
  id: 0,
  compraId: 0,
  produtoId: 0,
  produtoDescricao: "",
  quantidade: 0,
  valorUnitario: 0,
  valorTotal: 0,
};

